export const focusQueryKeys = {
  all: ["focus"] as const,
  threads: (workspaceId: string, query: string) => ["focus", "threads", workspaceId, query] as const,
  thread: (threadId: string) => ["focus", "thread", threadId] as const,
  messages: (threadId: string, branchId: string, headSequence: string) => [
    "focus",
    "messages",
    threadId,
    branchId,
    headSequence,
  ] as const,
  run: (runId: string) => ["focus", "run", runId] as const,
  source: (sourceId: string) => ["focus", "source", sourceId] as const,
  contextTasks: (workspaceId: string) => ["focus", "context", "tasks", workspaceId] as const,
  proposal: (proposalId: string) => ["focus", "proposal", proposalId] as const,
};
